import axios from "axios";
import {BASE_CLIENT_URL, BASE_URL} from '../../../api/Api'

export const LOGIN_URL = `${BASE_CLIENT_URL}/auth/login`;
export const REGISTER_URL = `${BASE_CLIENT_URL}/auth/register`;
export const REQUEST_PASSWORD_URL = `${BASE_CLIENT_URL}/auth/forgot-password`;

export const ME_URL = `${BASE_URL}/client/auth/me`;

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register({email,nom,prenoms,phone,password}) {
  return axios.post(REGISTER_URL, { email,nom,prenoms,phone,password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken(token) {

  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL,{
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });
}
